<template src="./template.html"></template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';

export default {
  name: 'MenuCard',
  props: ['data'],
  data() {
    return {
      visibleMenus: [],
      currentLevel: 100,
      baseHeight: 0,
      addonHeight: 63,
    };
  },
  computed: {
    ...mapGetters(['get_user', 'get_user_permission']),
    dataLinks() {
      return this.data;
    },
  },
  mounted() {
    this.startingBaseHeight();
  },
  methods: {
    isLinkVisible(permission) {
      if( permission === true ){
        return true;
      }
      if( this.get_user_permission(permission) !== undefined ) {
        return this.get_user_permission(permission).view;
      }
      return false;
    },
    isPanelVisible(panel) {
      return true;
    },
    closeMenu() {
      this.$store.dispatch('SET_ACTIVE_MENU', '');
      this.$store.dispatch('SET_LEFT_ACTIVE_MENU', '');
      this.$store.dispatch('CLOSE_NAVIGATION');
      this.$store.dispatch('CLOSE_LEFT_NAVIGATION');
    },
    startingBaseHeight() {
      this.baseHeight = this.data[0].links.length * this.addonHeight + 66 + 'px';
    },
    searchableBaseHeight(panelName) {
      for (let ii = 0; ii < this.data.length; ii++) {
        if (this.data[ii].hasOwnProperty('submenu') && this.data[ii].submenu === panelName) {
          this.baseHeight = this.data[ii].links.length * this.addonHeight + 66 + 'px';
        }
      }
    },
    menuTransition(panelName, value) {
      const self = this;
      if(value === 'decrese'){
        // Move submenu out
        const indexIn = self.visibleMenus.indexOf(panelName);
        setTimeout(function(){
          if (indexIn > -1) {
            self.visibleMenus.splice(indexIn, 1);
          }
        }, 400);
        this.currentLevel = this.currentLevel - 100;
        if(this.visibleMenus.length === 1) {
          this.startingBaseHeight();
        } else {
          this.searchableBaseHeight(this.visibleMenus[this.visibleMenus.length - 2]);
        }
      } else {
        // Move submenu in
        this.visibleMenus.push(panelName);
        this.currentLevel = this.currentLevel + 100;
        this.searchableBaseHeight(panelName);
      }
    },
  },
};
</script>
